import { z } from 'zod';
import { DocumentCategory } from '@triedge/admissions-domain';
import { UnixTimestamp } from '@triedge/domain-core/types';

export const PortalDocumentSchema = z.object({
  id: z.string(),
  applicationId: z.string(),
  studentId: z.string().nullable().optional(),
  resourceId: z.string(),
  category: DocumentCategory,
  uploadedBy: z.string(),
  uploadedAt: UnixTimestamp,
  verified: z.boolean().optional(),
  verifiedAt: UnixTimestamp.nullable().optional(),
  createdAt: UnixTimestamp,
  updatedAt: UnixTimestamp.nullable().optional(),
});
export type PortalDocument = z.infer<typeof PortalDocumentSchema>;
